<template lang="html">
  <section
    class="mask"
    ref="mask"
    @click="mask()"
    v-show="visiable"
    @touchmove.prevent
  >
    <div class="codeQrCode">
      <p class="title">{{ title }}</p>
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      // title
      type: String,
      default: ''
    },
    visiable: {
      // 控制模态框的显示隐藏
      type: Boolean,
      default: false
    }
  },
  methods: {
    mask() {
      this.$emit('mask', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 50%;
  z-index: 2000;
  width: 100%;
  max-width: 7.5rem;
  transform: translate3d(-50%, 0, 0);
  background-color: rgba(0, 0, 0, 0.3);

  .codeQrCode {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2001;
    width: rem(560px);
    overflow: hidden;
    text-align: center;
    word-break: break-all;
    background-color: #fff;
    border-radius: 0.12rem;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);

    .title {
      font-size: rem(36px);
      color: #121212;
      text-align: center;
      line-height: rem(44px);
      font-weight: bold;
      padding: rem(46px) 0 rem(10px);
    }
  }
}
.mask_img {
  width: 316px;
  height: 200px;
  z-index: 999;
  position: fixed;
  right: 0px;
}
</style>
